import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import Radium from 'radium';
import update from 'react-addons-update';
import {push, goBack} from 'react-router-redux';
import Color from 'color';
import {Checkbox} from 'rmwc';
import {Snackbar} from 'rmwc';
import queryString from 'query-string';

import * as styles from '../../styles';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {request} from '../../containers/actions';
import {addToCart} from '../cart/actions';
import {imageUrl} from '../../utilities/requests';
import Folder from './folder';
import Notes from './notes';
import * as actions from './actions';
import Content from '../../content-manager/content';
import {setSelectedItems} from '../tree/actions';
import {refresh as paginatorRefresh, removeItem, clearSelection, addItem} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';
import CommentList from '../../social/comment';
import { resizer600 } from '../../responsiver';
// import buttons from './buttons';

//Radium(Book);
export default class Book extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        height: PropTypes.number,
    }

    static defaultProps = {
        height: 29,
    }

    initialState = {
        data: {chapters: []},
        userAdded: false,
        hoverBook: false
    }

    state = _.clone(this.initialState)

    usersListFields = [
        ...this.context.user.hasPerm('book.edit') ? [{field: 'id', label: window.gettext('ID')}] : [],
        {field: item => item.name ? item.name : '-', label: window.gettext('Center')},
        {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
        {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
        ...this.context.user.hasPerm('book.content')
            ? [
                {
                    field: item => item.owner
                        ? `${item.owner.firstname} ${item.owner.lastname}`
                        : window.gettext('Guest User'),
                    label: window.gettext('Added By'),
                },
                {
                    field: item => item.confirmed ? '\u2713' : '\u2715',
                    label: window.gettext('Confirmed'),
                },
            ]
            : [],
    ]

    usersFiltersSelector = createSelector(
        [
            (__, state) => state.data.id,
            () => this.props.store.getIn(['regionsTreeFilter']),
            () => this.props.store.getIn(['citiesTreeFilter']),
        ],
        id => [
            {
                field: 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('regionsTreeFilter')}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('citiesTreeFilter')}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            region: this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                )),
            },
            {
                field: 'book',
                selected: {[id]: null},
            },
        ],
    )

    usersSorts = [
        {name: 'name', label: window.gettext('Name')},
        {name: 'city', label: window.gettext('City')},
        {name: 'region', label: window.gettext('Region')},
    ]

    usersEvents = {
        onClick: item => this.context.user.hasPerm('book.content') ? this.setState({currentUser: item.id}) : null,
    }

    usersEditPropsSelector = createSelector(
        [
            (__, state) => state.data.id,
        ],
        id => ({
            close: id => {
                if (id)
                    this.setState({addUser: false, currentUser: undefined, userAdded: true});
                else
                    this.setState({addUser: false, currentUser: undefined});
            },
            hiddenDefaults: {
                book: {id}, ...(this.context.user.hasPerm('book.content') ? {confirmed: true} : {}),
                owner: 0,
            },
        }),
    )
        
    usersActionsSelector = createSelector(
        [
            (__, props) => props.admin,
            () => this.props.store.getIn(['users', 'selected']).size > 0,
        ],
        admin => admin
            ? this.props.store.getIn(['users', 'selected']).size > 0
                ? [
                    {
                        label: window.gettext('Confirm'),
                        action: async () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna confirm these %(count)s book users?'),
                                {count: this.props.store.getIn(['users', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            await this.context.store.dispatch(request({
                                path: '/book-user/',
                                body: this.props.store.getIn(['users', 'selected']).map((__, id) => ({id, confirmed: true})).toArray(),
                                method: 'PATCH',
                            }));
                            this.context.store.dispatch([
                                paginatorRefresh(this.props.store.getIn(['users', 'elementId'])),
                                clearSelection(this.props.store.getIn(['users', 'elementId'])),
                            ]);
                        },
                    },
                    {
                        label: window.gettext('Remove'),
                        action: async () => {
                            if (!window.confirm(window.interpolate(
                                window.gettext('Are you sure you wanna remove these %(count)s book users?'),
                                {count: this.props.store.getIn(['users', 'selected']).size.persian()},
                                true,
                            )))
                                return;
                            await this.context.store.dispatch(request({
                                path: '/book-user/?' + queryString.stringify({
                                    id: this.props.store.getIn(['users', 'selected']).keySeq().join(','),
                                }),
                                method: 'DELETE',
                            }));
                            this.context.store.dispatch([
                                ...this.props.store.getIn(['users', 'selected']).map(
                                    (__, id) => removeItem(id, this.props.users.elementId),
                                ).toArray(),
                                clearSelection(this.props.store.getIn(['users', 'elementId'])),
                            ]);
                        },
                    },
                ]
                : []
            : [],
    )

    usersButtonActions = [
        {
            label: window.gettext('Add'),
            default: true,
            action: () => this.setState({addUser: true}),
        },
    ]

    examinationsListFields = [
        ...this.context.user.hasPerm('book.edit') ? [{field: 'id', label: window.gettext('ID')}] : [],
        {field: 'title', label: window.gettext('Title')},
        // {
        //     field: item => _.map(item.grades, grade => grade.title).join(window.gettext(',') + ' '),
        //     label: window.gettext('Grade'),
        // },
        {field: item => item.date ? item.date.toJalali().persian() : '-', label: window.gettext('Date')},
        ...this.context.user.hasPerm('book.content')
            ? [
                // {field: 'registered', label: window.gettext('Registered')},
                {field: 'read_students', label: window.gettext('Read Students')},
            ]
            : [],
        {
            style: {width: '1px'},
            field: item => item.buyable
                ? <button
                    key='purchase'
                    style={{
                        ...styles.button,
                        padding: '.25em',
                        boxSizing: 'border-box',
                    }}
                    onClick={event => {
                        event.stopPropagation();
                        this.context.store.dispatch(addToCart({
                            item: item.unrestricted_store_item,
                            count: 1,
                        }));
                    }}
                    onMouseUp={({target}) => target.blur()}>
                    {window.gettext('Purchase')}
                </button>
                : item.takable
                    ? <button
                        key='reports'
                        style={{
                            ...styles.button,
                            padding: '.25em',
                            boxSizing: 'border-box',
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + item.id + '/take/',
                            ));
                        }}
                        onMouseUp={({target}) => target.blur()}>
                        {window.gettext('Run Examination')}
                    </button>
                    : item.online_beginning > Date.now()
                        ? window.gettext('Waiting for executing time')
                        : window.gettext('Deadline has reached'),
            label: '',
        },
        { 
            style: {width: '1px'},
            field: item => item.read_papers > 0
                ? <button
                    key='reports'
                    style={{
                        ...styles.button,
                        padding: '.25em',
                        boxSizing: 'border-box',
                    }}
                    onClick={event => {
                        event.stopPropagation();
                        this.context.store.dispatch(push(
                            this.context.store.getState().getIn(
                                ['routing', 'locationBeforeTransitions', 'pathname'],
                            ) + item.id + '/' + (this.props.module === 'students' ? '' : 'report/'),
                        ));
                    }}
                    onMouseUp={({target}) => target.blur()}>
                    {window.gettext('Report')}
                </button>
                : null,
            label: '',
        },
        ...this.context.user.hasPerm('book.content')
            ? [
                {
                    style: {width: '1px'},
                    field: item => <button
                        key='edit'
                        style={{
                            ...styles.button,
                            padding: '.25em',
                            boxSizing: 'border-box',
                        }}
                        onClick={event => {
                            event.stopPropagation();
                            this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + item.id + '/',
                            ));
                        }}
                        onMouseUp={({target}) => target.blur()}>
                        {window.gettext('Edit')}
                    </button>,
                    label: '',
                },
            ]
            : [],
        // ...(this.props.user === 'student'
        //     ? []
        //     : [
        //         {
        //             style: {width: '1px'},
        //             field: item => <button
        //                 key='students'
        //                 style={{
        //                     ...styles.button,
        //                     padding: '.25em',
        //                     boxSizing: 'border-box',
        //                 }}
        //                 onClick={event => {
        //                     event.stopPropagation();
        //                     this.context.store.dispatch(push(
        //                         this.context.store.getState().getIn(
        //                             ['routing', 'locationBeforeTransitions', 'pathname'],
        //                         ) + item.id + '/students/',
        //                     ));
        //                 }}
        //                 onMouseUp={({target}) => target.blur()}>
        //                 {window.gettext('Students')}
        //             </button>,
        //             label: '',
        //         },
        //     ]
        // ),
    ]

    examinationsSorts = [
        {name: 'title', label: window.gettext('Title')},
        {name: 'date', label: window.gettext('Date')},
    ]

    examinationsFiltersSelector = createSelector(
        [
            (__, {state}) => state.data.id,
            (__, {props}) => props.params.chapter,
        ],
        (id, chapter) => [
            ...(chapter === '0'
                ? [{
                    field: 'books',
                    selected: {[id]: null},
                }]
                : [{
                    field: 'chapters',
                    selected: {[chapter]: null},
                }]
            ),
        ]
    )

    examinationsEditPropsSelector = createSelector(
        [
            (__, state) => state.data.id,
        ],
        id => ({
            close: () => this.setState({addUser: false, currentUser: undefined}),
            hiddenDefaults: {
                book: {id},
                restricted: false,
                ...this.context.user.hasPerm('book.content') ? {confirmed: true} : {},
                owner: 0,
            },
        }),
    )

    examinationsButtonActions = [
        {
            label: window.gettext('New Examination'),
            action: this.newExamination.bind(this),
        },
    ]

    examinationsTooltip(item) {
        return this.context.user.hasPerm('book.content') ? (item.note || '').persian() : '';
    }

    constructor(props, context) {
        super(props, context);
        this.examinationsTooltip = this.examinationsTooltip.bind(this);
        this.fullscreenChanged = this.fullscreenChanged.bind(this);
    }

    getTab(props) {
        return props.tab || props.params.tab;
    }

    async componentDidMount() {
        if (this.props.params.bookId === '0') {
            return;
        }
        if (this.props.params.chapter === undefined) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + '0/introduction/'));
        }
        if (this.props.params.chapter && this.getTab(this.props) === undefined) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + 'introduction/'));
        }
        document.addEventListener('webkitfullscreenchange', this.fullscreenChanged, false);
        document.addEventListener('mozfullscreenchange', this.fullscreenChanged, false);
        document.addEventListener('fullscreenchange', this.fullscreenChanged, false);
        document.addEventListener('MSFullscreenChange', this.fullscreenChanged, false);
        this.fetch.bind(this)();
    }

    componentWillUnmount() {
        if (this.timeoutId)
            clearTimeout(this.timeoutId);
        document.removeEventListener('webkitfullscreenchange', this.fullscreenChanged, false);
        document.removeEventListener('mozfullscreenchange', this.fullscreenChanged, false);
        document.removeEventListener('fullscreenchange', this.fullscreenChanged, false);
        document.removeEventListener('MSFullscreenChange', this.fullscreenChanged, false);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.bookId !== nextProps.params.bookId) {
            this.setState(this.initialState);
        }
    }

    async componentDidUpdate(prevProps) {
        if (this.props.params.bookId === '0') {
            return;
        }
        if (!this.timeoutId && !this.state.initialized && this.props.params.chapter && this.state.data.id) {
            _.forEach(new Array(this.state.data.chapters.length + 1), (__, index) =>
                window.getComputedStyle(this.refs[`chapter-${index}`]).getPropertyValue('display'));
            this.timeoutId = setTimeout(() => {
                this.setState({initialized: true});
                this.timeoutId = undefined;
            }, 1500);
        }
        if (
            (this.props.params.bookId !== prevProps.params.bookId || this.props.params.chapter !== prevProps.params.chapter)
            && this.props.params.chapter === undefined
        ) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + '0/introduction/'));
        }
        if (this.getTab(this.props) !== this.getTab(prevProps) && this.props.params.chapter && this.getTab(this.props) === undefined) {
            const path = this.context.store.getState().getIn(
                ['routing', 'locationBeforeTransitions', 'pathname'],
            );
            this.context.store.dispatch(push(path + 'introduction/'));
        }
        if (this.getTab(this.props) !== this.getTab(prevProps) && this.getTab(this.props) === 'about_compiler') {
            this.setState({compilersInitialized: false});
            setTimeout(() => this.setState({compilersInitialized: true}), 300);
        }
        if (this.props.params.bookId !== prevProps.params.bookId) {
            this.fetch.bind(this)();
        }
        if (
            this.getTab(this.props) !== this.getTab(prevProps) &&
            _.includes(
                [
                    'files',
                    'videos',
                    'related_books',
                    'powerpoint',
                    'sample_pages',
                    'library',
                    'answers',
                    'teaching_guide',
                    'games',
                ],
                this.getTab(this.props),
            )
        ) {
            const index = this.props.params.chapter === '0' ? null : _.findIndex(
                this.state.data.chapters,
                chapter => chapter.id === Number(this.props.params.chapter),
            );
            const item = index === null ? this.state.data : this.state.data.chapters[index];
            const folder = _.find(item.folders, folder => folder.title === this.getTab(this.props));
            if (!folder && this.context.user.hasPerm('book.edit')) {
                const response = await this.context.store.dispatch(request({
                    path: index === null
                        ? `/book/${item.id}/create_folder/`
                        : `/chapter/${item.id}/create_folder/`,
                    body: {title: this.getTab(this.props)},
                    method: 'POST',
                }));
                if (index === null)
                    this.setState(update(this.state, {data: {folders: {$push: [response]}}}));
                else {
                    const updatedItem = update(item, {folders: {
                        $push: [response],
                    }});
                    this.setState(update(this.state, {data: {chapters: {$splice: [[index, 1, updatedItem]]}}}));
                }
            }
        }
        if (this.props.params.chapter !== prevProps.params.chapter) {
            if (this.context.user.hasPerm('book.edit')) {
                if (!prevProps.params.chapter || prevProps.params.chapter === '0') {
                    this.setState(update(this.state, {data: {compilers: {
                        $set: this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).toArray(),
                    }}}));
                }
                else {
                    const index = _.findIndex(this.state.data.chapters, chapter => chapter.id === Number(prevProps.params.chapter));
                    const prevChapter = index === -1 ? null : this.state.data.chapters[index];
                    if (prevChapter && !_.isEqual(
                        prevChapter.compilers,
                        this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).toArray(),
                    )) {
                        const updatedChapter = update(prevChapter, {
                            compilers: {$set: this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).toArray()},
                            modified: {$set: true},
                        });
                        this.setState(update(this.state, {data: {chapters: {
                            $splice: [[index, 1, updatedChapter]],
                        }}}));
                    }
                }
                if (this.props.params.chapter) {
                    if (this.props.params.chapter === '0') {
                        this.context.store.dispatch(setSelectedItems(
                            _.map(this.state.data.compilers, item => item),
                            'compiler',
                            this.props.store.getIn(['compilersTree', 'elementId']),
                        ));
                    }
                    else {
                        const index = _.findIndex(this.state.data.chapters, chapter => chapter.id === Number(this.props.params.chapter));
                        const currentChapter = index === -1 ? null : this.state.data.chapters[index];
                        this.context.store.dispatch(setSelectedItems(
                            _.map(currentChapter.compilers, item => item),
                            'compiler',
                            this.props.store.getIn(['compilersTree', 'elementId']),
                        ));
                    }
                }
            }
        }
    }

    fullscreenChanged() {
        this.setState({fullscreen: document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen});
    }

    imageSource(image, width) {
        if (image) {
            if (image.length === 32)
                return imageUrl(image, {
                    width: width || Number.parseInt(16 * 77 * 3 / 10),
                    type: 'contain',
                });
            else
                return image;
        }
        else
            return '';
    }

    async save() {
        try {
            await this.context.store.dispatch(request({
                path: '/chapter/',
                body: _.map(
                    _.filter(
                        this.state.data.chapters,
                        chapter => (
                            chapter.modified ||
                            chapter.id === Number(this.props.params.chapter) &&
                            !_.isEqual(
                                chapter.compilers,
                                this.props.store.getIn(['compilersTree', 'selected']).map((__, item) => Number.parseInt(item)).keySeq().toArray(),
                            )
                        ),
                    ),
                    chapter => {
                        const payload = {
                            id: chapter.id,
                            caption: chapter.caption,
                            index: chapter.index,
                            description: chapter.description,
                            color: chapter.color,
                            related_links: chapter.related_links,
                            compilers: Number(this.props.params.chapter) === chapter.id
                                ? this.props.store.getIn(['compilersTree', 'selected']).toJS()
                                : chapter.compilers,
                        };
                        if (chapter.cover_photo_content_type) {
                            payload['cover_photo'] = chapter.cover_photo;
                            payload['cover_photo_content_type'] = chapter.cover_photo_content_type;
                        }
                        return payload;
                    },
                ),
                method: 'PATCH',
            }));
            const id = this.state.data.id;
            const payload = {
                ...this.state.data,
                grade: {id: this.props.store.getIn(['gradeTree', 'selected']).keySeq().first()},
                category: {id: this.props.store.getIn(['categoryTree', 'selected']).keySeq().first()},
                compilers: _.map(
                    this.props.params.chapter === '0' ? this.props.store.getIn(['compilersTree', 'selected']).toJS() : this.state.data.compilers,
                    (__, item) => ({
                        id: item,
                        description: (_.find(
                            this.state.data.compilers,
                            _item => _item.id === Number.parseInt(item),
                        ) || {}).description,
                    }),
                ),
                coworkers: this.props.store.getIn(['coworkersTree', 'selected']).map((__, item) => ({
                    id: item,
                    description: (_.find(
                        this.state.data.coworkers,
                        _item => _item.id === Number.parseInt(item),
                    ) || {}).description,
                })).toArray(),
                editors: this.props.store.getIn(['editorsTree', 'selected']).map((__, item) => ({
                    id: item,
                    description: (_.find(
                        this.state.data.editors,
                        _item => _item.id === Number.parseInt(item),
                    ) || {}).description,
                })).toArray(),
                print_type: this.props.store.getIn(['printTypeTree', 'selected']).keySeq().first(),
                chapters: undefined,
            };
            const response = await this.context.store.dispatch(request({
                path: `/book/${id}/`,
                body: payload,
                method: 'PATCH',
            }));
            await this.context.store.dispatch(actions.setData(
                response,
                this.props.store.getIn(['main', 'elementId']),
            ));
            this.setState({data: response, initialized: false});
            return true;
        }
        catch (exception) {
            console.error(exception);
            // this.context.store.dispatch(actions.setErrors(
            //     exception,
            //     this.props.store.getIn(['main', 'elementId']),
            // ));
            return false;
        }
    }

    async delete_() {
        try {
            const id = this.state.data.id;
            await this.context.store.dispatch(request({
                path: `/book/${id}/`,
                method: 'DELETE',
            }));
            this.context.store.dispatch(push('/book/'));
            return true;
        }
        catch (exception) {
            console.error(exception);
            // this.context.store.dispatch(actions.setErrors(
            //     exception,
            //     this.props.store.getIn(['main', 'elementId']),
            // ));
            return false;
        }
    }

    async deleteChapter(id) {
        try {
            await this.context.store.dispatch(request({
                path: `/chapter/${id}/`,
                method: 'DELETE',
            }));
            const index = _.findIndex(
                this.state.data.chapters,
                chapter => chapter.id === id,
            );
            this.setState(update(this.state, {data: {chapters: {$splice: [[index, 1]]}}}));
            return true;
        }
        catch (exception) {
            console.error(exception);
            // this.context.store.dispatch(actions.setErrors(
            //     exception,
            //     this.props.store.getIn(['main', 'elementId']),
            // ));
            return false;
        }
    }

    async fetch() {
        this.setState(this.initialState);
        if (!this.props.params.bookId) {
            const title = prompt(window.gettext('Enter book title') + ':');
            if (title === null) {
                this.context.store.dispatch(goBack());
                return;
            }
            const payload = {
                title: title.persian(),
                category: {id: this.props.location.query.category},
            };
            const response = await this.context.store.dispatch(request({
                path: '/book/',
                body: payload,
                method: 'POST',
            }));
            this.context.store.dispatch(push(`/book/${response.id}/`));
            return;
        }
        const response = await this.context.store.dispatch(request({
            path: `/book/${this.props.params.bookId}/`,
        }));
        await this.context.store.dispatch(actions.setData(
            response,
            this.props.store.getIn(['main', 'elementId']),
        ));
        this.setState({data: response, initialized: false});
    }

    addFile(folderUUID, file) {
        const index = this.props.params.chapter === '0' ? null : _.findIndex(
            this.state.data.chapters,
            chapter => chapter.id === Number(this.props.params.chapter),
        );
        const item = index === null ? this.state.data : this.state.data.chapters[index];
        const folderIndex = _.findIndex(item.folders, folder => folder.uuid === folderUUID);
        const updatedFolder = update(item.folders[folderIndex], {files: {
            $push: [file],
        }});
        if (index === null)
            this.setState(update(this.state, {data: {folders: {
                $splice: [[index, 1, updatedFolder]],
            }}}));
        else {
            const updatedItem = update(this.state.data.chapters[index], {folders: {
                $splice: [[folderIndex, 1, updatedFolder]],
            }});
            this.setState(update(this.state, {data: {chapters: {
                $splice: [[index, 1, updatedItem]],
            }}}));
        }
    }

    updateFile(folderUUID, file) {
        const index = this.props.params.chapter === '0' ? null : _.findIndex(
            this.state.data.chapters,
            chapter => chapter.id === Number(this.props.params.chapter),
        );
        const item = index === null ? this.state.data : this.state.data.chapters[index];
        const folderIndex = _.findIndex(item.folders, folder => folder.uuid === folderUUID);
        const fileIndex = _.findIndex(item.folders[folderIndex].files, file_ => file_.uuid === file.uuid);
        const updatedFolder = update(item.folders[folderIndex], {files: {
            $splice: [[fileIndex, 1, file]],
        }});
        if (index === null)
            this.setState(update(this.state, {data: {folders: {
                $splice: [[index, 1, updatedFolder]],
            }}}));
        else {
            const updatedItem = update(this.state.data.chapters[index], {folders: {
                $splice: [[folderIndex, 1, updatedFolder]],
            }});
            this.setState(update(this.state, {data: {chapters: {
                $splice: [[index, 1, updatedItem]],
            }}}));
        }
    }

    removeFile(folderUUID, fileUUID) {
        const index = this.props.params.chapter === '0' ? null : _.findIndex(
            this.state.data.chapters,
            chapter => chapter.id === Number(this.props.params.chapter),
        );
        const item = index === null ? this.state.data : this.state.data.chapters[index];
        const folderIndex = _.findIndex(item.folders, folder => folder.uuid === folderUUID);
        const fileIndex = _.findIndex(item.folders[folderIndex].files, file_ => file_.uuid === fileUUID);
        const updatedFolder = update(item.folders[folderIndex], {files: {
            $splice: [[fileIndex, 1]],
        }});
        if (index === null)
            this.setState(update(this.state, {data: {folders: {
                $splice: [[index, 1, updatedFolder]],
            }}}));
        else {
            const updatedItem = update(this.state.data.chapters[index], {folders: {
                $splice: [[folderIndex, 1, updatedFolder]],
            }});
            this.setState(update(this.state, {data: {chapters: {
                $splice: [[index, 1, updatedItem]],
            }}}));
        }
    }

    renderInfo() {
        return <div
            style={{
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                overflowY: 'overlay',
                overflowX: 'hidden',
                paddingTop: '.5em',
                paddingLeft: '1em',
                boxSizing: 'border-box',
            }}>
            {this.context.user.hasPerm('book.edit')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                    }}>
                    <input
                        key='title'
                        style={styles.field}
                        placeholder={window.gettext('Title')}
                        value={this.state.data.title || ''}
                        onChange={({target: {value}}) =>
                            this.setState(update(this.state, {data: {title: {$set: value.persian()}}}))
                        }
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.edit')
                ? <div
                    style={{
                        float: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('gradeTree')}
                        readonly
                        resource='grade'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Grade')}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.edit')
                ? <div
                    style={{
                        float: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('categoryTree')}
                        readonly
                        resource='book-category'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Category')}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.edit')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('printTypeTree')}
                        readonly
                        resource='print-type'
                        multiSelection={false}
                        combobox
                        label={window.gettext('Print Type')}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.edit')
                ? <div
                    style={{
                        float: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                    }}>
                    <input
                        key='pages'
                        style={styles.field}
                        placeholder={window.gettext('Pages Count')}
                        value={(this.state.data.pages || '').persian()}
                        onChange={({target: {value}}) =>
                            this.setState(update(this.state, {data: {pages: {$set: value.english()}}}))
                        }
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('compilersTree')}
                        readonly
                        resource='compiler'
                        itemLabel={object => `${object.firstname} ${object.lastname}`}
                        multiSelection
                        combobox
                        label={window.gettext('Compilers')}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('coworkersTree')}
                        readonly
                        resource='compiler'
                        itemLabel={object => `${object.firstname} ${object.lastname}`}
                        multiSelection
                        combobox
                        label={window.gettext('Coworkers')}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('editorsTree')}
                        readonly
                        resource='compiler'
                        itemLabel={object => `${object.firstname} ${object.lastname}`}
                        multiSelection
                        combobox
                        label={window.gettext('Editors')}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(100% - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                    }}>
                    {window.gettext('Description')}:
                    <Content
                        key='description'
                        style={{
                            ...styles.field,
                            height: undefined,
                            minHeight: '5em',
                        }}
                        inline
                        content={(this.state.data.description || '')}
                        onChange={content =>
                            this.setState(update(this.state, {data: {description: {$set: content}}}))
                        }
                    />
                </div>
                : this.state.data.description
                    ? <div
                        style={{
                            ...styles.shadowBox,
                            marginBottom: '.5em',
                            marginLeft: '.5em',
                            marginRight: '.5em',
                            height: 'calc(100% - .5em)',
                            overflowX: 'hidden',
                            overflowY: 'auto',
                            ...styles.content,
                        }}
                        dangerouslySetInnerHTML={{
                            __html: this.state.data.description,
                        }}
                    />
                    : null
            }
        </div>;
    }

    renderChapterInfo(id) {
        const index = _.findIndex(this.state.data.chapters, chapter => chapter.id === id);
        const data = this.state.data.chapters[index];
        return <div
            style={{
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(50% - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                    }}>
                    {window.gettext('Caption')}:
                    <input
                        key='caption'
                        style={styles.field}
                        value={(data.caption || '').persian()}
                        onChange={({target: {value}}) => {
                            const updatedChapter = update(data, {
                                caption: {$set: value.persian()},
                                modified: {$set: true},
                            });
                            this.setState(update(this.state, {data: {chapters: {
                                $splice: [[index, 1, updatedChapter]],
                            }}}));
                        }}
                    />
                </div>
                : null
            }
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(100% - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                    }}>
                    {window.gettext('Description')}:
                    <Content
                        key='description'
                        style={{
                            ...styles.field,
                            height: undefined,
                            minHeight: '5em',
                        }}
                        inline
                        content={(data.description || '')}
                        onChange={content => {
                            const updatedChapter = update(data, {
                                description: {$set: content},
                                modified: {$set: true},
                            });
                            this.setState(update(this.state, {data: {chapters: {
                                $splice: [[index, 1, updatedChapter]],
                            }}}));
                        }}
                    />
                </div>
                : data.description
                    ? <div
                        style={{
                            ...styles.shadowBox,
                            margin: '.5em',
                            ...styles.content,
                        }}
                        dangerouslySetInnerHTML={{
                            __html: data.description,
                        }}
                    />
                    : null
            }
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: 'calc(100% / 3 - 1em)',
                        marginLeft: '.5em',
                        marginRight: '.5em',
                        marginBottom: '1em',
                        fontSize: '.9em',
                    }}>
                    <Tree
                        store={this.props.store.get('compilersTree')}
                        readonly
                        resource='compiler'
                        itemLabel={object => `${object.firstname} ${object.lastname}`}
                        multiSelection
                        combobox
                        label={window.gettext('Compilers')}
                        filter={{book: this.state.data.id}}
                    />
                </div>
                : null
            }
        </div>;
    }

    updateProfilePicture(data) {
        _.forEach(
            this.state.data.compilers,
            (item, index) => {
                if (item.id !== data.id)
                    return;
                const updatedCompiler = update(item, {
                    profile_picture: {$set: data.profile_picture},
                });
                this.setState(update(this.state, {data: {compilers: {
                    $splice: [[index, 1, updatedCompiler]],
                }}}));
            },
        );
        _.forEach(
            this.state.data.coworkers,
            (item, index) => {
                if (item.id !== data.id)
                    return;
                const updatedCoworker = update(item, {
                    profile_picture: {$set: data.profile_picture},
                });
                this.setState(update(this.state, {data: {coworkers: {
                    $splice: [[index, 1, updatedCoworker]],
                }}}));
            },
        );
        _.forEach(
            this.state.data.editors,
            (item, index) => {
                if (item.id !== data.id)
                    return;
                const updatedEditor = update(item, {
                    profile_picture: {$set: data.profile_picture},
                });
                this.setState(update(this.state, {data: {editors: {
                    $splice: [[index, 1, updatedEditor]],
                }}}));
            },
        );
    }

    renderCompilers() {
        return <div
            style={{
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>
            <input
                type='file'
                accept='image/*'
                ref='profilePictureSelector'
                style={{display: 'none'}}
                onClick={() => {
                    this.refs.profilePictureSelector.value = '';
                }}
                onChange={async () => {
                    const id = this.refs.profilePictureSelector.dataset.userId;
                    const file = this.refs.profilePictureSelector.files[0];
                    const requestBody = new FormData();
                    requestBody.append('profile_picture', file);
                    const response = await this.context.store.dispatch(request({
                        path: `/user/${id}/`,
                        body: requestBody,
                        method: 'PATCH',
                    }));
                    this.updateProfilePicture.bind(this)(response);
                }}
            />
            {this.state.data.compilers.length > 0
                ? <div style={{clear: 'both'}}>
                    {window.gettext('Compilers')}:
                </div>
                : null
            }
            {_.map(this.state.data.compilers, (item, index) => <div
                key={'compiler-' + item.id}
                style={{
                    float: 'right',
                    width: 'calc(50% - 1em)',
                    height: `calc(6em + ${1.6 * 1.1}em + .5em)`,
                    margin: '.25em',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}>
                <div style={{fontSize: '1.1em', height: '1.6em', color: '#f68e21'}}>
                    {item.firstname} {item.lastname}
                </div>
                <div
                    key={'compiler-description-' + item.id}
                    style={{
                        float: 'right',
                        fontSize: '.9em',
                        color: '#282563',
                        position: this.context.user.hasPerm('book.content') && this.state.editing === 'compiler-' + item.id
                            ? undefined
                            : 'relative',
                        overflow: this.context.user.hasPerm('book.content') && this.state.editing === 'compiler-' + item.id
                            ? undefined
                            : 'hidden',
                        width: `calc(100% - ${6 / .9}em)`,
                        height: this.context.user.hasPerm('book.content') && this.state.editing === 'compiler-' + item.id
                            ? undefined
                            : 'calc(7em / .9)',
                    }}
                    onClick={() => this.setState({editing: 'compiler-' + item.id})}>
                    {this.context.user.hasPerm('book.content') && this.state.editing === 'compiler-' + item.id
                        ? <textarea
                            key={'compiler-description-' + item.id}
                            ref={component => component && component.focus()}
                            style={{
                                ...styles.field,
                                width: '100%',
                                height: '6em',
                            }}
                            value={(item.description || '').persian()}
                            onBlur={() => this.state.editing === 'compiler-' + item.id
                                ? this.setState({editing: null})
                                : null}
                            onChange={({target: {value}}) => {
                                const updatedCompiler = update(item, {
                                    description: {$set: value.persian()},
                                });
                                this.setState(update(this.state, {data: {compilers: {
                                    $splice: [[index, 1, updatedCompiler]],
                                }}}));
                            }}>
                        </textarea>
                        : _.map(
                            (item.description || '').split('\n'),
                            (text, index) => <div
                                key={index}
                                style={{
                                    position: 'absolute',
                                    fontSize: '.9em',
                                    top: `${1.4 * index}em`,
                                    opacity: this.state.compilersInitialized ? '1' : '0',
                                    width: '100%',
                                    transition: `opacity 300ms ${90 * index}ms`,
                                    whiteSpace: 'pre',
                                }}>
                                {text}
                            </div>,
                        )
                    }
                </div>
                <img
                    style={{
                        float: 'left',
                        width: '4.5em',
                        height: '5em',
                        cursor: this.context.user.hasPerm('book.content') ? 'pointer' : undefined,
                        objectFit: 'cover',
                        padding: '.2em',
                        borderRadius: '50%',
                        border: '.0625em solid #cacaca',
                    }}
                    src={item.profile_picture
                        ? imageUrl(item.profile_picture, {
                            width: 72,
                            height: 96,
                            type: 'cover',
                        })
                        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                    }
                    onClick={({button}) => {
                        if (!this.context.user.hasPerm('book.content'))
                            return;
                        if (button === 2)
                            return;
                        this.refs.profilePictureSelector.dataset.userId = item.id;
                        this.refs.profilePictureSelector.click();
                    }}
                    onMouseDown={async ({button}) => {
                        if (button === 2) {
                            if (!window.confirm(window.gettext('Are you sure you wanna remove this photo?')))
                                return;
                            const response = await this.context.store.dispatch(request({
                                path: `/user/${item.id}/`,
                                body: {profile_picture: null},
                                method: 'PATCH',
                            }));
                            this.updateProfilePicture.bind(this)(response);
                            return;
                        }
                    }}
                    onContextMenu={event => event.preventDefault()}
                />
            </div>)}
            {this.state.data.coworkers.length > 0
                ? <div style={{clear: 'both'}}>
                    {window.gettext('Coworkers')}:
                </div>
                : null
            }
            {_.map(this.state.data.coworkers, (item, index) => <div
                key={'coworker-' + item.id}
                style={{
                    float: 'right',
                    width: 'calc(50% - 1em)',
                    height: `calc(6em + ${1.6 * 1.1}em + .5em)`,
                    margin: '.25em',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}>
                <div style={{fontSize: '1.1em', height: '1.6em', color: '#f68e21'}}>
                    {item.firstname} {item.lastname}
                </div>
                <div
                    key={'coworker-description-' + item.id}
                    style={{
                        float: 'right',
                        fontSize: '.9em',
                        color: '#282563',
                        position: this.context.user.hasPerm('book.content') && this.state.editing === 'coworker-' + item.id
                            ? undefined
                            : 'relative',
                        overflow: this.context.user.hasPerm('book.content') && this.state.editing === 'coworker-' + item.id
                            ? undefined
                            : 'hidden',
                        width: `calc(100% - ${6 / .9}em)`,
                        height: this.context.user.hasPerm('book.content') && this.state.editing === 'coworker-' + item.id
                            ? undefined
                            : 'calc(7em / .9)',
                    }}
                    onClick={() => this.setState({editing: 'coworker-' + item.id})}>
                    {this.context.user.hasPerm('book.content') && this.state.editing === 'coworker-' + item.id
                        ? <textarea
                            key={'coworker-description-' + item.id}
                            ref={component => component && component.focus()}
                            style={{
                                ...styles.field,
                                width: '100%',
                                height: '6em',
                            }}
                            value={(item.description || '').persian()}
                            onBlur={() => this.state.editing === 'coworker-' + item.id
                                ? this.setState({editing: null})
                                : null}
                            onChange={({target: {value}}) => {
                                const updatedCoworker = update(item, {
                                    description: {$set: value.persian()},
                                });
                                this.setState(update(this.state, {data: {coworkers: {
                                    $splice: [[index, 1, updatedCoworker]],
                                }}}));
                            }}>
                        </textarea>
                        : _.map(
                            (item.description || '').split('\n'),
                            (text, index) => <div
                                key={index}
                                style={{
                                    position: 'absolute',
                                    fontSize: '.9em',
                                    top: `${1.4 * index}em`,
                                    opacity: this.state.compilersInitialized ? '1' : '0',
                                    width: '100%',
                                    transition: `opacity 300ms ${90 * index}ms`,
                                    whiteSpace: 'pre',
                                }}>
                                {text}
                            </div>,
                        )
                    }
                </div>
                <img
                    style={{
                        float: 'left',
                        width: '4.5em',
                        height: '5em',
                        cursor: this.context.user.hasPerm('book.content') ? 'pointer' : undefined,
                        objectFit: 'cover',
                        padding: '.2em',
                        borderRadius: '50%',
                        border: '.0625em solid #cacaca',
                    }}
                    src={item.profile_picture
                        ? imageUrl(item.profile_picture, {
                            width: 72,
                            height: 96,
                            type: 'cover',
                        })
                        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                    }
                    onSuccess={({target}) => target.style.opacity = '1'}
                    onError={({target}) => target.style.opacity = '0'}
                    onClick={({button}) => {
                        if (!this.context.user.hasPerm('book.content'))
                            return;
                        if (button === 2)
                            return;
                        this.refs.profilePictureSelector.dataset.userId = item.id;
                        this.refs.profilePictureSelector.click();
                    }}
                    onMouseDown={async ({button}) => {
                        if (button === 2) {
                            if (!window.confirm(window.gettext('Are you sure you wanna remove this photo?')))
                                return;
                            const response = await this.context.store.dispatch(request({
                                path: `/user/${item.id}/`,
                                body: {profile_picture: null},
                                method: 'PATCH',
                            }));
                                    this.updateProfilePicture.bind(this)(response);
                                    return;
                        }
                    }}
                    onContextMenu={event => event.preventDefault()}
                />
            </div>)}
            {this.state.data.editors.length > 0
                ? <div style={{clear: 'both'}}>
                    {window.gettext('Editors')}:
                </div>
                : null
            }
            {_.map(this.state.data.editors, (item, index) => <div
                key={'editor-' + item.id}
                style={{
                    float: 'right',
                    width: 'calc(50% - 1em)',
                    height: `calc(6em + ${1.6 * 1.1}em + .5em)`,
                    margin: '.25em',
                    padding: '.25em',
                    boxSizing: 'border-box',
                }}>
                <div style={{fontSize: '1.1em', height: '1.6em', color: '#f68e21'}}>
                    {item.firstname} {item.lastname}
                </div>
                <div
                    key={'editor-description-' + item.id}
                    style={{
                        float: 'right',
                        fontSize: '.9em',
                        color: '#282563',
                        position: this.context.user.hasPerm('book.content') && this.state.editing === 'editor-' + item.id
                            ? undefined
                            : 'relative',
                        overflow: this.context.user.hasPerm('book.content') && this.state.editing === 'editor-' + item.id
                            ? undefined
                            : 'hidden',
                        width: `calc(100% - ${6 / .9}em)`,
                        height: this.context.user.hasPerm('book.content') && this.state.editing === 'editor-' + item.id
                            ? undefined
                            : 'calc(7em / .9)',
                    }}
                    onClick={() => this.setState({editing: 'editor-' + item.id})}>
                    {this.context.user.hasPerm('book.content') && this.state.editing === 'editor-' + item.id
                        ? <textarea
                            key={'editor-description-' + item.id}
                            ref={component => component && component.focus()}
                            style={{
                                ...styles.field,
                                width: '100%',
                                height: '6em',
                            }}
                            value={(item.description || '').persian()}
                            onBlur={() => this.state.editing === 'editor-' + item.id
                                ? this.setState({editing: null})
                                : null}
                            onChange={({target: {value}}) => {
                                const updatedEditor = update(item, {
                                    description: {$set: value.persian()},
                                });
                                this.setState(update(this.state, {data: {editors: {
                                    $splice: [[index, 1, updatedEditor]],
                                }}}));
                            }}>
                        </textarea>
                        : _.map(
                            (item.description || '').split('\n'),
                            (text, index) => <div
                                key={index}
                                style={{
                                    position: 'absolute',
                                    fontSize: '.9em',
                                    top: `${1.4 * index}em`,
                                    opacity: this.state.compilersInitialized ? '1' : '0',
                                    width: '100%',
                                    transition: `opacity 300ms ${90 * index}ms`,
                                    whiteSpace: 'pre',
                                }}>
                                {text}
                            </div>,
                        )
                    }
                </div>
                <img
                    style={{
                        float: 'left',
                        width: '4.5em',
                        height: '5em',
                        cursor: this.context.user.hasPerm('book.content') ? 'pointer' : undefined,
                        objectFit: 'cover',
                        padding: '.2em',
                        borderRadius: '50%',
                        border: '.0625em solid #cacaca',
                    }}
                    src={item.profile_picture
                        ? imageUrl(item.profile_picture, {
                            width: 72,
                            height: 96,
                            type: 'cover',
                        })
                        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
                    }
                    onSuccess={({target}) => target.style.opacity = '1'}
                    onError={({target}) => target.style.opacity = '0'}
                    onClick={({button}) => {
                        if (!this.context.user.hasPerm('book.content'))
                            return;
                        if (button === 2)
                            return;
                        this.refs.profilePictureSelector.dataset.userId = item.id;
                        this.refs.profilePictureSelector.click();
                    }}
                    onMouseDown={async ({button}) => {
                        if (button === 2) {
                            if (!window.confirm(window.gettext('Are you sure you wanna remove this photo?')))
                                return;
                            const response = await this.context.store.dispatch(request({
                                path: `/user/${item.id}/`,
                                body: {profile_picture: null},
                                method: 'PATCH',
                            }));
                                this.updateProfilePicture.bind(this)(response);
                                return;
                        }
                    }}
                    onContextMenu={event => event.preventDefault()}
                />
            </div>)}
        </div>;
    }

    renderInfography() {
        return <div
            style={{
                width: 'calc(100% - .5em)',
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                marginLeft: '.5em',
                position: 'relative',
            }}>
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{position: 'absolute', left: '1em', top: '1em', cursor: 'pointer'}}
                    onClick={() => this.setState(update(this.state, {data: {
                        infography: {$set: ''},
                        infography_content_type: {$set: '-'},
                    }}))}>
                    <i className='fa-times'></i>
                </div>
                : null
            }
            <img
                style={{
                    width: '100%',
                    height: '100%',
                    marginLeft: '.5em',
                    objectFit: 'cover',
                    cursor: this.context.user.hasPerm('book.content') ? 'pointer' : undefined,
                    boxShadow: '0 6px 6px 0 rgba(119,119,119,0.75)',
                    borderRadius: '6px',
                }}
                src={this.imageSource.bind(this)(this.state.data.infography, 880)}
                onClick={() => {
                    if (!this.context.user.hasPerm('book.content'))
                        return;
                    this.refs.fileSelector.dataset.target = 'infography';
                    this.refs.fileSelector.click();
                }}
            />
        </div>;
    }

    renderUsers() {
        return <div
            style={{
                paddingLeft: '.5em',
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                display: 'flex',
                flexDirection: 'column',
            }}>
            <div style={{fontSize: '1.5em'}}>
                &nbsp;&nbsp;{window.pgettext('book', 'Users')}
            </div>
            {window.gettext('If your school uses this book you can add your school\'s name.')}
            <PaginatedContainer
                store={this.props.store.get('users')}
                resource='book-user'
                title=''
                listFields={this.usersListFields}
                sorts={this.usersSorts}
                selectable={this.context.user.hasPerm('book.content')}
                filters={this.usersFiltersSelector(this.props.store, this.state)}
                pageSize={25}
                active={this.state.addUser ? 'add' : this.state.currentUser}
                readonly={!this.context.user.hasPerm('book.content')}
                events={this.usersEvents}
                editDialog
                sidebar={this.context.user.hasPerm('book.content')}
                editProps={this.usersEditPropsSelector(this.props.store, this.state)}
                actions={this.usersActionsSelector(this.props.store, this.props)}
                buttonActions={this.usersButtonActions}
            />
        </div>;
    }

    async newExamination() {
        const title = prompt(window.gettext('Title') + ':');
        if (!title)
            return;
        const response = await this.context.store.dispatch(request({
            path: '/examination/',
            body: {
                title,
                online: true,
                ...(this.props.params.chapter === '0'
                    ? {books: [this.state.data.id]}
                    : {chapters: [Number(this.props.params.chapter)]}
                ),
            },
            method: 'POST',
        }));
        this.context.store.dispatch(addItem(
            response,
            this.props.store.getIn(['examinations', 'pageSize']),
            this.props.store.getIn(['examinations', 'elementId']),
        ));
    }

    renderExaminations() {
        if (this.props.children)
            return this.props.children;
        return <div
            style={{
                paddingLeft: '.5em',
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                display: 'flex',
                flexDirection: 'column',
            }}>
            <PaginatedContainer
                store={this.props.store.get('examinations')}
                resource='examination'
                title={window.gettext('Examinations')}
                listFields={this.examinationsListFields}
                sorts={this.examinationsSorts}
                tooltip={this.examinationsTooltip}
                selectable={this.context.user.hasPerm('book.content')}
                filters={this.examinationsFiltersSelector(this.props.store, {props: this.props, state: this.state})}
                pageSize={25}
                readonly={!this.context.user.hasPerm('book.content')}
                editDialog
                sidebar={this.context.user.hasPerm('book.content')}
                editProps={this.examinationsEditPropsSelector(this.props.store, this.state)}
                buttonActions={this.examinationsButtonActions}
            />
        </div>;
    }

    renderRelatedLinks(id) {
        const index = _.findIndex(this.state.data.chapters, chapter => chapter.id === id);
        const data = this.state.data.chapters[index];
        return <div
            style={{
                height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>
            {this.context.user.hasPerm('book.content')
                ? <div
                    style={{
                        float: 'right',
                        clear: 'right',
                        width: '100%',
                        padding: '.5em',
                    }}>
                    <Content
                        key='related_links'
                        style={{
                            ...styles.field,
                            height: undefined,
                            minHeight: '5em',
                        }}
                        inline
                        content={(this.state.data.related_links || '')}
                        onChange={content => {
                            const updatedChapter = update(data, {
                                related_links: {$set: content},
                                modified: {$set: true},
                            });
                            this.setState(update(this.state, {data: {chapters: {
                                $splice: [[index, 1, updatedChapter]],
                            }}}));
                        }}
                    />
                </div>
                : data.related_links
                    ? <div
                        style={{
                            ...styles.shadowBox,
                            margin: '.5em',
                            ...styles.content,
                        }}
                        dangerouslySetInnerHTML={{
                            __html: data.related_links,
                        }}
                    />
                    : null
            }
        </div>;
    }

    render() {
        if (this.props.params.bookId === '0') {
            return <div>{window.gettext('Books')}</div>;
        }
        if (!this.props.params.chapter || !this.state.data.id)
            return null;
        const index = _.findIndex(this.state.data.chapters, chapter => chapter.id === Number(this.props.params.chapter));
        const currentChapter = index === -1 ? null : this.state.data.chapters[index];
        return <span > 
            <Snackbar
                show={this.state.userAdded}
                onClose={() => this.setState({userAdded: false})}
                message={window.gettext('Your school will be added after confirmation!')}
            />
            <div style={resizer600}>
            {<p style={{display: 'flex',
                       alignContent: 'center',
                       justifyContent: 'center',
                       fontWeight: 'bold',
                       fontSize:'20px'}}> 20 درصد تخفیف به مناسب شروع سال تحصیلی جدید</p>}
        
            {this.context.user.hasPerm('book.edit') || this.context.user.hasPerm('book.content')
                ? <div style={{position: 'relative'}}>
                    <div
                        style={{
                            display: 'flex',
                            alignContent: 'center',
                            justifyContent: 'center',
                            fontWeight: '500',
                            fontSize: '1.4em',
                        }}>
                        <div>
                            {this.state.data
                                ? this.state.data.title
                                : null
                            }
                        </div>
                    </div>
                    <div style={{position: 'absolute', width: '100%', top: '0'}}>
                        <div
                            style={{
                                // ...styles.buttonContainer,
                                float: 'left',
                                marginRight: '.5em',
                            }}>
                            {this.state.data.id
                                ? <div
                                    style={{
                                        ...styles.checkboxField,
                                        marginRight: '.5em',
                                        fontSize: '.9em',
                                    }}>
                                    <Checkbox
                                        key='published'
                                        checked={this.state.data.published}
                                        onChange={({target: {checked}}) =>
                                            this.setState(update(this.state, {data: {published: {
                                                $set: checked,
                                            }}}))
                                        }>
                                        {window.gettext('Published')}
                                    </Checkbox>
                                </div>
                                : null
                            }
                            <button
                                key='save'
                                style={{...styles.defaultButton, marginRight: '.5em'}}
                                onClick={async () => {
                                    if (!window.confirm(window.gettext('Are you sure you wanna save this book?')))
                                        return;
                                    if (!(await this.save.bind(this)()))
                                        alert(window.gettext('Failed to save'));
                                }}>
                                {window.gettext('Apply')}
                            </button>
                        </div>
                    </div>
                </div>
                : null
            }
            <div style={{width: '100%', display: 'inline-block', paddingTop: '.25em'}}>
                <input
                    type='file'
                    accept='image/*'
                    ref='fileSelector'
                    style={{display: 'none'}}
                    multiple
                    onClick={() => {
                        this.refs.fileSelector.value = '';
                    }}
                    onChange={async () => {
                        const file = this.refs.fileSelector.files[0];
                        const data = await window.readFile(file);
                        if (this.refs.fileSelector.dataset.target === 'infography')
                            this.setState(update(this.state, {data: {
                                infography: {$set: data},
                                infography_content_type: {$set: file.type},
                            }}));
                        else if (this.props.params.chapter === '0')
                            this.setState(update(this.state, {data: {
                                cover_photo: {$set: data},
                                cover_photo_content_type: {$set: file.type},
                            }}));
                        else {
                            const index = _.findIndex(
                                this.state.data.chapters,
                                chapter => chapter.id === Number(this.props.params.chapter),
                            );
                            const updatedChapter = update(this.state.data.chapters[index], {
                                cover_photo: {$set: data},
                                cover_photo_content_type: {$set: file.type},
                                modified: {$set: true},
                            });
                            this.setState(update(this.state, {data: {chapters: {
                                $splice: [[index, 1, updatedChapter]],
                            }}}));
                        }
                    }}
                />
                <div
                    key='cover'
                    style={{
                        width: '21.5em',
                        float: 'right',
                        position: 'relative',
                        // backgroundColor:'red',
                        ':hover': {
                            position: 'relative',
                        },
                    }}>
                    <div
                        key='chapters'
                        style={{
                            position: 'absolute',
                            left: '0',
                            width: '10em',
                            transition: 'width 400ms',
                            ':hover': {
                                opacity: '1',
                            },
                        }}>
                            
                        <div onMouseEnter={(e)=>this.setState(e=>{
                            return{
                                ...e,
                                hoverBook: true
                            }
                        })} 
                            onMouseLeave={(e)=>this.setState(e=>({
                                    hoverBook: false}))
                            }
                            style={{width: '10em', direction: 'ltr'}}>
                            
                            {_.map(
                                [
                                    {
                                        id: 0,
                                        caption: this.state.data
                                            ? this.state.data.title
                                            : window.gettext('Introduction'),
                                        color: this.state.data.color,
                                    },
                                    ..._.sortBy(this.state.data.chapters, 'index'),
                                ],
                                (chapter, index) => <button
                                    key={'chapter-' + index}
                                    ref={'chapter-' + index}
                                    style={{
                                        ...(Number(this.props.params.chapter) === chapter.id
                                            ? {
                                                ..._.pickBy(styles.activeButton, (__, key) => key !== 'borderRadius'),
                                                backgroundColor: chapter.color
                                                    ? chapter.color
                                                    : styles.activeButton.backgroundColor,
                                                width: '100%',
                                            }
                                            : {
                                                ..._.pickBy(styles.button, (__, key) => key !== 'borderRadius'),
                                                backgroundColor: chapter.color || '#9a9a9a',
                                                opacity: Radium.getState(this.state, 'cover', ':hover') ||
                                                !this.state.initialized || Number(this.props.params.chapter) === chapter.id || window.mobile
                                                    ? '1'
                                                    : '.8',
                                                width: this.state.hoverBook ||
                                                !this.state.initialized || window.mobile
                                                    ? '100%'
                                                    : `${1 / .9}em`,
                                            }),
                                        minWidth: undefined,
                                        color: 'white',
                                        display: 'block',
                                        position: 'relative',
                                        direction: 'rtl',
                                        ':focus': undefined,
                                        marginTop: '.5em',
                                        borderTopLeftRadius: '.35em',
                                        borderBottomLeftRadius: '.35em',
                                        overflow: 'hidden',
                                        transition: `width 600ms ${index * 50}ms`,
                                    }}
                                    onClick={() => {
                                        this.context.store.dispatch(push(`/book/${this.props.params.bookId}/${chapter.id}/introduction/`));
                                    }}>
                                        
                                    {Radium.getState(this.state, 'cover', ':hover') && this.context.user.hasPerm('book.edit')
                                        ? <div
                                            style={{
                                                position: 'absolute',
                                                top: '.5em',
                                                right: '.5em',
                                                width: '5em',
                                            }}>
                                            {chapter.id !== 0
                                                ? <i
                                                    key='close'
                                                    style={{float: 'right'}}
                                                    className='fa-times'
                                                    onClick={event => {
                                                        event.stopPropagation();
                                                        if (!window.confirm(window.gettext('Are you sure you wanna delete this chapter?')))
                                                            return;
                                                        if (!this.deleteChapter.bind(this)(chapter.id))
                                                            alert(window.gettext('Failed to delete'));
                                                    }}>
                                                </i>
                                                : null
                                            }
                                            <i
                                                key='color'
                                                style={{float: 'right', marginRight: '.25em'}}
                                                className='fa-paint-brush'
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    const color = prompt(
                                                        window.gettext('Enter chapter color') + ':',
                                                        chapter.color || '',
                                                    );
                                                    if (color === null)
                                                        return;
                                                    if (chapter.id === 0) {
                                                        this.setState(update(this.state, {data: {
                                                            color: {$set: color},
                                                        }}));
                                                    }
                                                    else {
                                                        const index = _.findIndex(
                                                            this.state.data.chapters,
                                                            chapter_ => chapter_.id === chapter.id,
                                                        );
                                                        const updatedChapter = update(this.state.data.chapters[index], {
                                                            color: {$set: color},
                                                            modified: {$set: true},
                                                        });
                                                        this.setState(update(this.state, {data: {chapters: {
                                                            $splice: [[index, 1, updatedChapter]],
                                                        }}}));
                                                    }
                                                }}>
                                            </i>
                                        </div>
                                        : null
                                    }
                                    <div style={{overflow: 'hidden', marginLeft: '.4em'}}>
                                        <div style={{width: `${9 / .9}em`}}>
                                            {chapter.caption}

                                        </div>
                                    </div>
                                </button>,
                            )}
                            {this.context.user.hasPerm('book.edit')
                                ? <button
                                    key={'chapter-new'}
                                    style={{
                                        ..._.pickBy(styles.button, (__, key) => key !== 'borderRadius'),
                                        minWidth: undefined,
                                        display: 'block',
                                        position: 'relative',
                                        direction: 'rtl',
                                        ':focus': undefined,
                                        opacity: Radium.getState(this.state, 'cover', ':hover') ||
                                        !this.state.initialized
                                            ? '1'
                                            : '.8',
                                        width: Radium.getState(this.state, 'cover', ':hover') ||
                                        !this.state.initialized
                                            ? '100%'
                                            : `${1 / .9}em`,
                                        color: 'white',
                                        backgroundColor: '#9a9a9a',
                                        marginTop: '.5em',
                                        borderTopLeftRadius: '.35em',
                                        borderBottomLeftRadius: '.35em',
                                        overflow: 'hidden',
                                        transition: `width 600ms ${(this.state.data.chapters.length + 1) * 50}ms`,
                                    }}
                                    onClick={async () => {
                                        const caption = prompt(window.gettext('Enter chapter title:')).persian();
                                        if (caption === null)
                                            return;
                                        const payload = {
                                            caption,
                                            book: {id: this.state.data.id},
                                            index: this.state.data.chapters.length === 0
                                                ? 1
                                                : _.maxBy(this.state.data.chapters, 'index').index + 1,
                                        };
                                        const response = await this.context.store.dispatch(request({
                                            path: '/chapter/',
                                            body: payload,
                                            method: 'POST',
                                        }));
                                        this.state.data.chapters.push(response);
                                    }}>
                                    <div style={{overflow: 'hidden', marginLeft: '.4em'}}>
                                        <div style={{width: `${9 / .9}em`}}>
                                            {window.gettext('New Chapter')}
                                        </div>
                                    </div>
                                </button>
                                : null
                            }
                        </div>
                    </div>
                    <img
                        style={{
                            display: 'block',
                            width: `${this.props.height / 29.7 * 21}em`,
                            height: `${this.props.height}em`,
                            objectFit: 'cover',
                            cursor: this.context.user.hasPerm('book.edit') ? 'pointer' : undefined,
                            marginLeft: '.75em',
                            marginRight: '.25em',
                            marginBottom: '.25em',
                            boxShadow: '0 6px 6px 0 rgba(119,119,119,0.75)',
                            borderRadius: '6px',
                        }}
                        src={this.props.params.chapter === '0'
                            ? this.imageSource.bind(this)(this.state.data.cover_photo)
                            : this.imageSource.bind(this)(_.find(
                                this.state.data.chapters,
                                chapter => chapter.id === Number(this.props.params.chapter),
                            ).cover_photo)
                        }
                        onClick={() => {
                            if (!this.context.user.hasPerm('book.edit'))
                                return;
                            this.refs.fileSelector.dataset.target = 'cover';
                            this.refs.fileSelector.click();
                        }}
                    />
                    {this.state.data.store_item.off
                        ? <div
                            style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                width: `${this.props.height / 29.7 * 21}em`,
                                height: `${this.props.height}em`,
                                marginRight: '.25em',
                                marginBottom: '.25em',
                                boxShadow: '0 6px 6px 0 rgba(119,119,119,0.75)',
                                borderRadius: '6px',
                                overflow: 'hidden',
                                pointerEvents: 'none'
                            }}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    right: '0',
                                    transform: 'translateX(50%) rotate(45deg)',
                                    transformOrigin: '50% 0',
                                    width: '10em',
                                    height: '5em',
                                    backgroundColor: 'red',
                                    textAlign: 'center',
                                    paddingTop: '1.5em',
                                    color: 'white',
                                    lineHeight: '1.5em',
                                    boxSizing: 'border-box',
                                }}>
                                <span style={{fontSize: '1.3em', fontWeight: '800'}}>
                                    {'%' + this.state.data.store_item.off.persian()}
                                    <br/>
                                    {window.gettext('Off')}
                                </span>
                            </div>
                        </div>
                        : null
                    }
                    {this.state.data.store_item.stock > 0 
                        ? <div style={{ top: 'calc(100% + 1.25em)', right: '1.25em', textAlign: 'center'}}>
                            <i
                                key='shop'
                                style={{
                                    cursor: 'pointer',
                                    color: styles.successColor,
                                    ':hover': {
                                        color: new Color(styles.successColor).darken(.2),
                                    },
                                }}
                                className='fa-shopping-cart fa-3x'
                                onClick={() => {
                                    this.context.store.dispatch(addToCart({
                                        item: this.state.data.store_item,
                                        count: 1,
                                    }));
                                }}>
                            </i>
                            <br/>
                            <span>
                                {window.gettext('Add to Card')}
                            </span>
                            <br/>
                            <span>
                              {/* <b>  {window.gettext('ارسال کتاب فیزیکی یکشنبه ها و چهارشنبه‌ها انجام می‌شود')} </b> */}
                            </span>
                            <br/>
                            <span>
                                {window.gettext('Price')}:&nbsp;
                                <span style={{display: 'inline-block', position: 'relative'}}>
                                    {(this.state.data.store_item.price || '-').persian()} {window.gettext('Tooman')}
                                    {this.state.data.store_item.off
                                        ? <>
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '40%',
                                                    left: '0',
                                                    width: '100%',
                                                    height: '.14em',
                                                    backgroundColor: 'red',
                                                    transformOrigin: '50% 50%',
                                                    transform: 'rotate(-10deg)',
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    top: '-.7em',
                                                    left: '-50%',
                                                    color: 'red',
                                                    transformOrigin: '50% 50%',
                                                    transform: 'rotate(-3deg)',
                                                    fontWeight: '800',
                                                    fontSize: '1.4em',
                                                }}>
                                                {(this.state.data.store_item.price * (1 - this.state.data.store_item.off / 100)).persian()}
                                                &nbsp;
                                                {window.gettext('Tooman')}
                                            </div>
                                        </>
                                        : null
                                    }
                                </span>
                            </span>
                        </div>
                        : null
                    }
                </div>
                <div style={{width: 'calc(100% - 21.5em)', height: `${this.props.height}em`, float: 'left'}}>
                    
                    <div
                        style={this.state.fullscreen
                            ? {
                                padding: '2em',
                                width: '100%',
                                height: '100%',
                                boxSizing: 'border-box',
                                position: 'relative',
                                overflow: 'auto',
                                backgroundColor: 'white' 
                            }
                            : {
                                paddingRight: '.5em',
                                height: '100%',
                                position: 'relative',
                            }
                        }
                        ref='content'>
                        <button
                            style={{
                                ...styles.button,
                                minWidth: undefined,
                                float: 'right',
                                width: '2.7em',
                                height: '2.7em',
                                marginLeft: '.5em',
                                marginRight: '.5em',
                                position: 'absolute',
                                top: this.state.fullscreen ? '.5em' : 'calc(100% + 1.2em)',
                                left: '.5em',
                                zIndex: '1',
                            }}
                            onClick={() => {
                                if (document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen) {
                                    (
                                        document.exitFullScreen ||
                                        document.webkitExitFullscreen ||
                                        document.mozCancelFullScreen ||
                                        document.msExitFullScreen
                                    ).bind(document)();
                                }
                                else {
                                    (
                                        this.refs.content.requestFullScreen ||
                                        this.refs.content.webkitRequestFullScreen ||
                                        this.refs.content.mozRequestFullScreen ||
                                        this.refs.content.msRequestFullScreen
                                    ).bind(this.refs.content)();
                                }
                            }}>
                            <i className='fa-arrows-alt fa-lg'></i>
                        </button>
                        {(() => {
                            let type;
                            switch (this.getTab(this.props)) {
                            case 'introduction':
                                if (this.props.params.chapter === '0') {
                                    return this.renderInfo.bind(this)();
                                }
                                else {
                                    return this.renderChapterInfo.bind(this)(Number(this.props.params.chapter));
                                }
                            case 'about_compiler':
                                return this.renderCompilers.bind(this)();
                            case 'infography':
                                return this.renderInfography.bind(this)();
                            case 'comments':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        paddingLeft: '3em',
                                        paddingRight: '3em',
                                        paddingTop: '1em',
                                        backgroundColor: 'white'   
                                    }}>
                                    <CommentList
                                        target={['book', this.state.data.id, 'comment']}
                                        placeholder={window.gettext('Enter your review about this book...')}
                                        rates={[
                                            window.pgettext('book', 'Rate 0'),
                                            window.pgettext('book', 'Rate 1'),
                                            window.pgettext('book', 'Rate 2'),
                                            window.pgettext('book', 'Rate 3'),
                                        ]}
                                        commentStyle={{
                                            body: {
                                                height: '11.3em',
                                                overflowX: 'hidden',
                                                overflowY: 'auto',
                                                borderRadius: '3px',
                                                border: '.0625em solid #9a9a9a',
                                                padding: '1em',
                                            },
                                        }}
                                        formStyle={{
                                            body: {
                                                maxHeight: '13.3em',
                                            },
                                        }}
                                    />
                                </div>;
                            case 'questions':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        paddingLeft: '8em',
                                        paddingRight: '8em',
                                        paddingTop: '1em',
                                    }}>
                                    <CommentList
                                        target={['book', this.state.data.id, 'question']}
                                        placeholder={window.gettext('Enter your question about this book...')}
                                        submitMessage={window.gettext('Your question will be answered shortly!')}
                                        bodyPreprocessor={body => body + '<div class="answer" style="font-size: calc(0.85 * 12pt);background-color: rgb(255, 225, 189);margin-bottom: 0.75em;padding-left: 0.5em;padding-right: 0.5em;color: rgb(40, 37, 99);width: 50%;">علامه حلی</div><p>جواب</p>'}
                                    />
                                </div>;
                            case 'users':
                                return this.renderUsers.bind(this)();
                            case 'term_examinations':
                                return this.renderExaminations.bind(this)();
                            case 'mistakes':
                                return <div
                                    style={{
                                        height: this.state.fullscreen ? undefined : `${this.props.height}em`,
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        paddingLeft: '8em',
                                        paddingRight: '8em',
                                        paddingTop: '1em',
                                    }}>
                                    <CommentList
                                        target={['chapter', Number(this.props.params.chapter), 'mistake']}
                                        placeholder={window.gettext('Enter the mistake you found in book...')}
                                        submitMessage={window.gettext('We will examine the issue you reported!')}
                                        commentStyle={comment => comment.extra.accepted
                                            ? {
                                                box: {boxShadow: undefined, border: `.0625em solid ${styles.successColor}`},
                                                border: `.0625em solid ${styles.successBorderColor}`,
                                                header: {backgroundColor: styles.successBackColor/*, color: styles.sucessColor*/},
                                            }
                                            : comment.extra.accepted === false 
                                                ? {
                                                    box: {boxShadow: undefined, border: `.0625em solid ${styles.alertColor}`},
                                                    border: `.0625em solid ${styles.alertBorderColor}`,
                                                    header: {backgroundColor: styles.alertBackColor, color: styles.alertColor},
                                                }
                                                : undefined
                                        }
                                        bodyPreprocessor={body => body + '<div class="answer" style="font-size: calc(0.85 * 12pt);background-color: rgb(255, 225, 189);margin-bottom: 0.75em;padding-left: 0.5em;padding-right: 0.5em;color: rgb(40, 37, 99);width: 50%;">علامه حلی</div><p>جواب</p>'}
                                        actions={[
                                            {
                                                icon: comment => comment.extra.accepted
                                                    ? 'fa-check-circle'
                                                    : comment.extra.accepted === false
                                                        ? 'fa-times-circle'
                                                        : 'fa-info-circle',
                                                action: async (comment, props) => {
                                                    await this.context.store.dispatch(request({
                                                        path: `/comment/${comment.id}/`,
                                                        method: 'PATCH',
                                                        body: {extra: {
                                                            ...comment.extra,
                                                            accepted: comment.extra.accepted
                                                                ? false
                                                                : comment.extra.accepted === false
                                                                    ? null
                                                                    : true,
                                                        }},
                                                    }));
                                                    props.refresh();
                                                },
                                            },
                                        ]}
                                    />
                                </div>;
                            case 'notes':
                                return <div style={{height: this.state.fullscreen ? undefined : `${this.props.height}em`}}>
                                    <Notes
                                        chapter={Number(this.props.params.chapter)}
                                        params={this.props.params}
                                        noteTypeTree={this.props.store.get('noteTypeTree')}
                                    />
                                </div>;
                            case 'related_links':
                                return this.renderRelatedLinks.bind(this)(Number(this.props.params.chapter));
                            case 'sample_pages':
                                if (!type)
                                    type = 'pdf';
                            case 'library':
                                if (!type)
                                    type = 'pdf';
                            case 'related_books':
                            case 'answers':
                            case 'teaching_guide':
                                if (!type)
                                    type = 'pdf';
                            case 'videos':
                                if (!type)
                                    type = 'video';
                            case 'games':
                                if (!type)
                                    type = 'swf';
                            case 'files':
                                if (!type)
                                    type = 'download';
                            case 'powerpoint':
                                const item = this.props.params.chapter === '0' ? this.state.data : _.find(
                                    this.state.data.chapters,
                                    chapter => chapter.id === Number(this.props.params.chapter),
                                );
                                return <Folder
                                    data={_.find(item.folders, folder => folder.title === this.getTab(this.props))}
                                    addFile={this.addFile.bind(this)}
                                    updateFile={this.updateFile.bind(this)}
                                    removeFile={this.removeFile.bind(this)}
                                    type={type}
                                    editable={this.context.user.hasPerm('book.edit')}
                                    height={this.state.fullscreen ? '100%' : `${this.props.height}em`}
                                />;
                            default:
                                return null;
                            }
                        })()}
                        
                    </div>
                </div>
            </div>
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <div
                    style={{
                        padding: '.375em',
                        marginTop: '.5em',
                        overflow: 'hidden',
                        width: `${(14.7 + .52) * .8 * (this.props.params.chapter === '0' ? 5 : 7)}em`,
                    }}>
                        {/* ***comment*** book details */}
                    {_.map(
                        this.props.params.chapter === '0'
                            ? {
                                introduction: window.gettext('Book Introduction'),
                                about_compiler: window.gettext('About Compiler'),
                                sample_pages: window.gettext('Sample Pages (PDF)'),
                                library: window.gettext('Library'),
                                infography: window.gettext('Infography'),
                                comments: window.gettext('Comments'),
                                questions: window.gettext('Questions and Answers'),
                                users: window.pgettext('book', 'Users'),
                                term_examinations: window.gettext('Term Examinations'),
                                [this.state.data.store_item.stock > 0 ? 'purchase' : 'purchase_']: window.gettext('خرید نسخه فیزیکی'),
                                buy_digitalbook: window.gettext('خرید نسخه الکترونیکی'),
                            }
                            : {
                                introduction: window.gettext('Chapter Introduction'),
                                files: window.gettext('Files'),
                                videos: window.gettext('Videos'),
                                related_books: window.gettext('Related Books'),
                                answers: window.gettext('Question Answers'),
                                games: window.gettext('Games'),
                                test_examinations: window.gettext('Test Examinations'),
                                mistakes: window.gettext('Mistakes'),
                                powerpoint: window.gettext('Power Point'),
                                ask_compiler_: window.gettext('Ask Compiler'),
                                notes: window.gettext('Notes'),
                                competitions_: window.gettext('Competitions'),
                                teaching_guide: window.gettext('Teaching Guide'),
                                [currentChapter.related_links ? 'related_links' : this.context.user.hasPerm('book.edit')
                                    ? 'related_links__'
                                    : 'related_links_'
                                ]: window.gettext('Related Links'),
                                [this.state.data.store_item.stock > 0 ? 'purchase' : 'purchase_']: window.gettext('Purchase'),
                            },
                        (text, id) => <div
                            key={id}
                            style={{
                                margin: '.25em',
                                background: `linear-gradient(${new Color(this.getTab(this.props) === id
                                    ? '#6B3904'
                                    : styles.primaryColor).lighten(1.4).hex()
                                }, ${new Color(this.getTab(this.props) === id
                                    ? '#6B3904'
                                    : styles.primaryColor).hex()
                                })`,
                                float: 'right',
                                borderRadius: '.6em',
                                fontSize: '.8em',
                                cursor: 'pointer',
                                ':active': {
                                    width: '14.7em',
                                },
                                ':hover': {
                                    width: '14.7em',
                                },
                            }}
                            onClick={() => {
                                const normalData = {
                                    ...this.state.data.store_item
                                    ,final_image:this.state.data.cover_photo || this.state.data.store_item?.final_image
                                };
                                if (id === 'purchase') {
                                    if (this.state.data.store_item.stock > 0)
                                        this.context.store.dispatch(addToCart({
                                            item: normalData,
                                            count: 1,
                                        }));
                                }
                                else if (id === "buy_digitalbook") {
                                    window.open(`https://livebook2.mhelli.com/bookshop?mainbookId=${this.props.params.bookId}`)
                                }
                                else if (!id.endsWith('_') || id.endsWidth('__')) {
                                    this.context.store.dispatch(push(
                                        `/book/${this.props.params.bookId}/${this.props.params.chapter}/${id.replace(/_*$/, '')}/`,
                                    ));
                                }
                            }}>
                            {/* <div
                            style={{
                                margin: '.25em',
                                background: `linear-gradient(${new Color(this.getTab(this.props) === 0
                                    ? '#6B3904'
                                    : styles.primaryColor).lighten(1.4).hex()
                                }, ${new Color(this.getTab(this.props) === id
                                    ? '#6B3904'
                                    : styles.primaryColor).hex()
                                })`,
                                float: 'right',
                                borderRadius: '.6em',
                                fontSize: '.8em',
                                cursor: 'pointer',
                                ':active': {
                                    width: '11.7em',
                                },
                                ':hover': {
                                    width: '11.7em',
                                },
                            }}
                            onClick={() => {
                                window.open('/')
                            }}> */}
                            <div
                                style={{
                                    marginTop: '.2em',
                                    marginBottom: '.2em',
                                    width: '14.7em',
                                    borderRadius: '2.5em/.5em',
                                    background: `linear-gradient(${new Color(this.getTab(this.props) === id
                                        ? '#6B3904'
                                        : styles.primaryColor).lighten(.8).hex()},
                                    ${new Color(this.getTab(this.props) === id
        ? '#6B3904'
        : styles.primaryColor).lighten(.4).hex()})`,
                                }}>
                                <i
                                    style={{
                                        verticalAlign: 'middle',
                                        marginLeft: '.2em',
                                        marginRight: '.2em',
                                        paddingTop: '.15em',
                                        color: id.endsWith('_')
                                            ? styles.disabledColor
                                            : Radium.getState(this.state, id, ':hover')
                                                ? this.getTab(this.props) === id
                                                    ? styles.primaryColor
                                                    : styles.secondaryColor
                                                : 'white',
                                    }}
                                    className='fa-plus fa-2x'>
                                </i>
                                {/* <svg width='104.88px' height='42.52px' viewBox='0 0 104.88 42.52'> */}
                                {/*     {buttons[id.replace(/_*$/, '')] ? buttons[id.replace(/_*$/, '')][0]('red') : null} */}
                                {/* </svg> */}
                                <button
                                    key={'button-' + id}
                                    style={{
                                        ..._.pickBy(this.getTab(this.props) === id
                                            ? styles.activeButton
                                            : styles.button, (value, key) =>
                                            !_.includes([
                                                'padding',
                                                'backgroundColor',
                                                'borderTop',
                                                'borderBottom',
                                                'borderLeft',
                                                'borderRight',
                                            ], key)),
                                        ':focus': undefined,
                                        fontSize: '1.2em',
                                        paddingTop: '.25em',
                                        paddingBottom: '.25em',
                                        whiteSpace: 'nowrap',
                                        width: '9.7em',
                                        color: id.endsWith('_')
                                            ? styles.disabledColor
                                            : Radium.getState(this.state, id, ':hover')
                                                ? this.getTab(this.props) === id ? styles.primaryColor : styles.secondaryColor
                                                : 'white',
                                        borderRadius: '.7em',
                                        border: 'none',
                                        boxShadow: `${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).hex()}
                                        1px 1px 1px 0px,
                                        ${new Color(styles.primaryColor).hex()} -1px 1px 1px 0px`,
                                        background: !id.endsWith('_') && Radium.getState(this.state, id, ':active')
                                            ? `linear-gradient(
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).hex()},
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(1.2).hex()} 93%,
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(.5).hex()})`
                                            : `linear-gradient(
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(.5).hex()},
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).lighten(1.2).hex()} 7%,
                                                ${new Color(this.getTab(this.props) === id ? '#6B3904' : styles.primaryColor).hex()})`,
                                    }}>
                                    {text}
                                </button>
                            </div>
                        </div>,
                    )}
                </div>
            </div>


            </div>
        </span>;
    }
}
